type JsonLdProps = {
	data: object | object[];
};

// Renders a JSON-LD <script>. Escapes '<' so the payload can't break out of
// the script element. Valid for crawlers anywhere in the document.
export const JsonLd = ({ data }: JsonLdProps) => {
	const json = JSON.stringify(data).replace(/</g, '\\u003c');

	return <script type='application/ld+json' dangerouslySetInnerHTML={{ __html: json }} />;
};
